import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";

// Styling
import { EmailLink } from "../styling/GlobalStyling";

export const FAQ = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - FAQ</title>
        <meta
          name="description"
          content="Här finner du svaren på de vanligaste frågorna om We Exist och det arbetet vi gör när det kommer till 
          it rekryteringar och jämställdhet."
        />
        <meta property="og:title" content="We Exist - FAQ" />
        <meta
          property="og:description"
          content="Här finner du svaren på de vanligaste frågorna om We Exist och det arbetet vi gör när det kommer till 
          it rekryteringar och jämställdhet."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="FAQ" />
      <FaqWrapper>
        <h2>Rekryterar ni endast kvinnliga kandidater?</h2>
        <p>
          Ja. I dagsläget är 100% av kandidaterna vi presenterar i en
          rekryteringsprocess till våra kunder kvinnor.
        </p>
        <h2>Vad kostar en rekrytering?</h2>
        <p>
          Det finns en mängd olika faktorer som påverkar priset på en
          rekrytering. Beroende på vilken roll ni ska rekrytera till, hur många
          kandidater ni vill ha, hur många års erfarenhet ni kräver samt hur
          stor del av processen ni vill att vi tar så varierar priset. Ett
          första steg är att vi får lyssna på era behov. Hör av er till oss så
          hittar vi en lösning som passar just ert företag.
        </p>
        <h2>
          Är det lagligt att ha ett rekryteringsbolag som endast rekryterar
          kvinnor?
        </h2>
        <p>
          Ja! Diskrimineringslagen förbjuder diskriminering som har samband med
          kön är i princip lika för samtliga diskrimineringsgrunder, men med
          några få undantag inom vissa samhällsområden. Till exempel är det
          tillåtet att behandla personer av olika kön olika om det är en del av
          ett planmässigt arbete för att främja jämställdhet, vilket We Exists
          arbete innefattar.
        </p>
        <h2>Kan ni hjälpa till med mer än bara rekrytering?</h2>
        <p>
          Absolut! Vi erbjuder våra kunder en helhetslösning när det kommer till
          att bland annat attrahera, rekrytera samt behålla kvinnor i sitt team.
          Vi erbjuder bland annat en så kallad Reality Check vilket är en
          inventering av bolaget genom titta på konkreta siffror och mäta data
          kring könsfördelningen i företaget. Vi hjälper även till med att
          skriva en jämställdhetspolicy, skapa annonser, ha workshops med ert
          team samt att vi coachar och utbildar chefer och ledare i inkluderande
          ledarskap. Vill du veta mer om våra tjänster? Kontakta oss så berättar
          vi gärna mer.
        </p>
        <h2>Kan ni hjälpa mig med annonsering och att skapa jobbannonser?</h2>
        <p>
          Yes, du kan räkna med oss! Vi hjälper er både med framtagning av
          kravprofil och att även skapa annonsen. Självklart kan vi också göra
          enbart annonsen! Men eftersom kravprofil och de ord ni väljer kan vara
          avgörande i om er annons kommer attrahera kvinnor är vi gärna med som
          bollplank från start och hjälper er att undvika de vanligaste
          fällorna. Annonser som attraherar kvinnor är också ofta favoriter även
          hos män, så chansen att hitta bra kandidater ökar maximalt!
        </p>
        <h2>
          Jag värnar om mitt team och skulle vilja bli coachad i hur man blir en
          mer inkluderande ledare, kan ni hjälpa mig med det?
        </h2>
        <p>
          Det hjälper vi gärna till med! Att bibehålla ett jämställt team och se
          till att kvinnliga medarbetare vill stanna kvar och känner sig
          inkluderade kräver jobb och engagemang. Vi coachar chefer och ledare i
          detta genom både intensiv ledarskapsutbildning men även kontinuerliga
          uppföljningar samt feedbackmöten under en längre period. Kontakta oss
          för att veta mer!
        </p>
        <h2>Tackar ni JA till alla företag som vill jobba med er?</h2>
        <p>
          Vi jobbar med många företag men långt ifrån alla som kontaktar oss. Vi
          tackar NEJ till företag som bara vill kvotera in en kvinnlig
          medarbetare till sitt team och tror att det kommer lösa hela
          jämställdhetsfrågan på företaget. Vi värnar om våra queens och jobbar
          därför endast med företag som är villiga att engagera sig till 100%
          och att aktivt jobba med jämställdhetsfrågan på ett långsiktigt plan.
          Innan vi rekryterar in en eller flera av våra queens till ert företag
          är det viktigt för oss att vi först har säkerställt att ni är villiga
          att lägga ner tid och engagemang på detta och att ni uppfyller vår
          kravlista.
        </p>
        <h2>
          Vad är en jämställdhetspolicy och kan ni hjälpa mig skapa en för mitt
          företag?
        </h2>
        <p>
          En diskrimineringspolicy är något som alla företag bör ha. En av de
          sju diskrimineringsgrunderna är kön och innefattas därför av
          diskrimineringspolicyn. I den diskrimineringspolicy som vi tar fram
          tillsammans med er lägger vi extra vikt vid jämställdhet och
          inkludering samt tar fram en handlingsplan för er.
        </p>
        <h2>Måste man ha en jämställdhetspolicy?</h2>
        <p>
          Alla företag med fler än 25 anställda måste enligt svensk lag ha en
          diskrimineringspolicy och i den ryms jämställdhet. Vi väljer att prata
          om det som en jämställdhetspolicy eftersom det är fokus för We Exist.
        </p>
        <h2>
          Vi skulle vilja boka in We Exist till en föreläsning eller event, går
          det?
        </h2>
        <p>
          Absolut! Vi pratar mer än gärna om jämställdhet och de positiva
          effekterna det kan ha för företag och organisationer. Hör av dig så
          ser vi vad just ni är intresserade av.
        </p>
        <h2>Tar ni emot praktikanter?</h2>
        <p>
          Ja! Vi tar gladeligen emot praktikanter. Maila ditt intresse till{" "}
          <EmailLink href="mailto:hello@weexist.se">
            {" "}
            hello@weexist.se
          </EmailLink>
          .
        </p>
        <PageLink to="/gdpr">
          <h2>
            Läs om GDPR <span>&#187;</span>
          </h2>
        </PageLink>
      </FaqWrapper>
    </>
  );
};

const FaqWrapper = styled.div`
  width: 90%;
  text-align: left;
  padding-bottom: 30px;

  h2 {
    margin-top: 25px;
  }
  span {
    font-size: 30px;
  }
`;

const PageLink = styled(Link)`
  text-decoration: none;
  color: #000 !important;
  /* margin-bottom: 20px; */
`;
